import { Person } from './Person';

export class Guest extends Person {

  /**
   * @property sponsorId
   *
   * Member ID of the sponsoring member (the member they are a guest
   * of).
   *
   * @type {string}
   */

}
